// Routes for IPS pages
export const URL_PATH_PREFIX_APIM = '/apimarketplace';
export const URL_PATH_PREFIX_BUY_INFO = '/buy-info';
export const URL_PATH_PREFIX_SUN = '/special-uen';
export const CART = 'cart';
export const PAYMENT_HISTORY = 'payment-history';
export const DETAILED = 'detailed';
export const CATEGORIES = 'categories';
export const MANAGEMENT = 'management';
export const SUBSCRIPTION_DATA_APIS = 'subscription-data-apis';
export const MANAGE_PROD_ACCESS = 'manage-prod-access';
export const APPLICATIONS = 'applications';
export const EVENT_SUBSCRIPTIONS = 'event-subscriptions';
export const USAGE_HISTORY = 'usage-history';
export const USAGE_INSIGHT = 'usage-insight';
export const PURCHASE_HISTORY = 'purchase-history';
export const ACCOUNT_INFO = 'account-info';
export const PAYMENT_SETTINGS = 'payment-settings';
export const GETTING_STARTED_PAGE = '/getting-started';
export const ENTITY_PAGE = '/entity';
export const NON_ACRA_ENTITY_PAGE = '/non-acra-entity-details';
export const ENTITY_DETAILS_PAGE = '/details';
export const PRODUCT_DOWNLOAD_VERIFY_PAGE = '/download/product/verify';
export const PRODUCT_DOWNLOAD_PAGE = '/download/product';
export const ENTITY_INFORMATION = '/entity-details';
export const PEOPLE = '/people';
export const PEOPLE_DETAILS = '/people-details';
export const PDF_PRODUCT_VERIFICATION = '/authenticate/pdf-product';
export const DETAILS_PAGE = '/details';
export const FREE_PRODUCTS_DOWNLOAD = '/download/free-product';
export const EXTRACTS_MANAGEMENT = '/extracts-management';
export const INFORMATION_PRODUCTS = '/info-products';
export const BUSINESS_PROFILE = 'business-profile';
export const CCFP = 'ccfp';
export const PEOPLE_PROFILE = 'people-profile';
export const EXTRACTS = 'extracts';
export const CERTIFICATES = 'certificates';
export const REGISTERS = 'registers';
export const FEDERATED_SEARCH_PAGE = '/search';
export const RESULTS = '/results';
export const SUN_GET_STARTED = '/getting-started';
export const SUN_FAQ = '/faqs';
export const OVERVIEW = 'overview';
export const BUY_INFORMATION = 'buy-information';
// Common routes
export const UNAUTHORIZED_PAGE = '/unauthorized';
export const APIM_HOME_PAGE = '/home';
export const DASHBOARD_PAGE = '/dashboard';
export const CLIENT_ID_PAGE = '/clientId';
// dummy
export const RECAPTCHA = '/recaptcha';
// refunds
export const REFUND_MODULE_ROUTE = '/refund';
export const REFUND_INTRODUCTION_ROUTE = `/create/instruction`;
export const REFUND_CREATE_ROUTE = `/create`;
// external payment module
export const EXTERNAL_PAYMENT_MODULE_ROUTE = '/payment';
